/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Tickets_RequiredInputs */

const en_settings_tickets_required = /** @type {(inputs: Settings_Tickets_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subject and description are required`)
};

const zh_settings_tickets_required = /** @type {(inputs: Settings_Tickets_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请填写标题和问题描述`)
};

/**
* | output |
* | --- |
* | "Subject and description are required" |
*
* @param {Settings_Tickets_RequiredInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_tickets_required = /** @type {((inputs?: Settings_Tickets_RequiredInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Tickets_RequiredInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_tickets_required(inputs)
	return zh_settings_tickets_required(inputs)
});
export { settings_tickets_required as "settings.tickets.required" }